<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="  card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white p-15 p-sm-20 p-md-25">
            <div class="d-lg-flex align-items-center justify-content-between mb-3">
              <h4 class="position-relative text-black fw-bold mb-0">Informations générales</h4>
              <router-link to="/liste-manifestes" class="btn btn-primary transition border-0 lh-1 fw-medium">
                <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
                Retour
              </router-link>
            </div>

            <div class="row g-3 pt-4">
              <div class="col-md-3">
                <label class="fs-5 mb-1">Code de l'émetteur</label>
                <p class="fw-semibold mb-0">{{ manifest?.carrierCode }}</p>
              </div>

              <div class="col-md-3">
                <label class="fs-5 mb-1">Référence Sic</label>
                <p class="fw-semibold mb-0">
                  <span class="badge bg-primary-subtle text-primary">{{ manifest?.manifestReference }}</span>
                </p>
              </div>

              <div class="col-md-2">
                <label class="fs-5 mb-1">Manifeste Date</label>
                <p class="fw-semibold mb-0">{{ format_Date(manifest?.manifestDate) }}</p>
              </div>

             
            </div>
          </div>

          <div class="row mt-4">
            <div v-for="(mani, index) in manifestBls" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <div class="card shadow-lg border-0 rounded-3 h-100">
                <div class="card-body d-flex flex-column">
                  <h5 class="card-title fw-bold text-primary">{{ mani.carrierBlNumber }}</h5>
                  <p class="text-muted fw-bold small mb-3">
                    Destinataire : {{ mani.consigneeName }}
                  </p>
                  <p class=" text-muted small mb-3">
                    NbrMarchandises : {{ mani.cargoItems.length }}
                  </p>
                  <p class=" text-muted small mb-3">
                    NbrConteneurs : {{ mani.containers.length }}
                  </p>
                  <!-- <a href="#" class="btn btn-sm btn-outline-primary mt-auto" @click.prevent="openModal(doc)">
                    Voir les détails
                  </a> -->

                  <button type="button" class="btn btn-sm btn-outline-primary mt-auto"
                    @click="$router.push({ name: 'ViewEquipMarchandPage', params: { id: mani.id } })">
                    Voir les détails
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date, showModal } from "@/utils/utils";
import { useRoute, useRouter } from "vue-router";
import { Manifest } from "@/models/Manifest";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "ViewManifest",
  setup: () => {
    const route = useRoute();
    const router = useRouter();
    const manifest = ref<Manifest | null>(null);
    const manifestBls = ref<any[]>([]);
    const selectedDocument = ref<any>(null);

    function getManifest(id: string) {
      return ApiService.get("/manifests", id)
        .then(({ data }) => {
          console.log("Donnees frontend:", data.data);
          manifest.value = data.data;
          manifestBls.value = data.data.manifestBls;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    

   
    onMounted(() => {
      const id = route.params.id as string;
      getManifest(id);
    });
    return {
      manifest,
      getManifest,
      format_Date,
      manifestBls,
      selectedDocument,
    };
  },
});
</script>

<style scoped>
  table tbody tr th {
    font-weight: bold;
    font-size: 16px;
  }

  .bg-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }

  .modal-content {
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .table td,
  .table th {
    padding: 0.75rem;
    vertical-align: middle;
  }

  .table-hover tbody tr:hover {
    background-color: rgba(102, 126, 234, 0.05);
  }

  code {
    background-color: #f8f9fa;
    padding: 0.2rem 0.4rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
  }
</style>
